export default __webpack_public_path__ + "static/media/13.59a1c86b.png";